/* عالم سمسم – على الموبايل: «أضف للسلة» يضيف المنتج ويسيب العميل يكمّل تسوّق
   بدل ما السلة تفتح على الشاشة كلها، بيظهر تنبيه صغير «اتضاف للسلة» + زرار «عرض السلة» */
(function () {
  if (window.SMSMADDSTAY) return; window.SMSMADDSTAY = 1;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var addAt = 0;
  function mobile() { return window.matchMedia('(max-width: 989px)').matches; }

  /* أي إضافة من فورم منتج (صفحة المنتج، الشريط الثابت، الإضافة السريعة من الكروت) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.closest && f.closest('product-form') && /\/cart\/add/.test(f.getAttribute('action') || '')) addAt = Date.now();
  }, true);

  function css() {
    if (document.getElementById('smsm-addstay-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-addstay-css';
    s.textContent = '' +
      '.smsm-added{position:fixed;z-index:2147483647;left:12px;right:12px;top:12px;display:flex;align-items:center;gap:10px;padding:12px 12px 12px 14px;border-radius:14px;background:#2B1748;color:#fff;box-shadow:0 18px 40px -14px rgba(43,23,72,.7);font-family:inherit;font-size:14px;font-weight:800;transform:translateY(-140%);opacity:0;pointer-events:none;transition:transform .35s cubic-bezier(.2,.8,.2,1),opacity .25s}' +
      '.smsm-added.is-on{transform:none;opacity:1;pointer-events:auto}' +
      '.smsm-added__i{flex:0 0 30px;width:30px;height:30px;border-radius:50%;background:#1E8E3E;display:flex;align-items:center;justify-content:center;font-size:16px}' +
      '.smsm-added__t{flex:1;min-width:0;line-height:1.4}' +
      '.smsm-added__go{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;padding:9px 14px;border-radius:10px;background:#D4AF37;color:#2B1748!important;font-weight:900;font-size:13px;white-space:nowrap;text-decoration:none!important;touch-action:manipulation;-webkit-tap-highlight-color:transparent}';
    document.head.appendChild(s);
  }

  var el = null, timer = 0;
  var CART = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  function toast() {
    css();
    if (!el) {
      el = document.createElement('div'); el.className = 'smsm-added'; el.dir = EN ? 'ltr' : 'rtl'; el.setAttribute('role', 'status');
      /* «عرض السلة» لينك عادي لصفحة السلة (أضمن على الموبايل من فتح السلة الجانبية) */
      el.innerHTML = '<span class="smsm-added__i" aria-hidden="true">✓</span><span class="smsm-added__t">' + (EN ? 'Added to your cart' : 'اتضاف للسلة') + '</span>' +
        '<a class="smsm-added__go" href="' + CART + '">' + (EN ? 'View cart' : 'عرض السلة') + '</a>';
      document.body.appendChild(el);
      el.querySelector('.smsm-added__go').addEventListener('click', function (ev) { ev.stopPropagation(); }, true);
    }
    clearTimeout(timer);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    timer = setTimeout(hide, 4500);
  }
  function hide() { if (el) el.classList.remove('is-on'); }

  function patch() {
    var cn = document.querySelector('cart-notification');
    if (!cn || cn.__smsmStay || typeof cn.open !== 'function') return !!(cn && cn.__smsmStay);
    var orig = cn.open;
    cn.open = function () {
      if (mobile() && addAt && Date.now() - addAt < 8000) {
        addAt = 0;
        toast();
        return Promise.resolve();
      }
      return orig.apply(this, arguments);
    };
    cn.__smsmStay = 1;
    return true;
  }
  if (!patch()) {
    var n = 0, iv = setInterval(function () { if (patch() || ++n > 40) clearInterval(iv); }, 250);
  }
})();

/* عالم سمسم – شريط الشراء الثابت على الموبايل يفضل ظاهر طول ما زرار «أضف للسلة» الأساسي مش باين على الشاشة
   (قبل ما العميل يوصله أو بعد ما يعدّيه) – زرار واحد بس، ويختفي لما الزرار الأساسي يبقى قدامه */
(function () {
  if (window.SMSMSTICKY2) return; window.SMSMSTICKY2 = 1;
  function init() {
    var bar = document.querySelector('[data-smsm-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var form = null, forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) { if (!forms[i].closest('[data-smsm-sticky], .quick-view, .modal, quick-view-modal, drawer-component, sticky-add-cart')) { form = forms[i]; break; } }
    var target = form && form.querySelector('[type="submit"]');
    if (!target) return;
    var mine = false;
    function set(on) {
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on);
      bar.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = on ? 0 : -1; });
      document.body.classList.toggle('smsm-sticky-pad', on);
    }
    new IntersectionObserver(function (es) {
      var e = es[0];
      if (e.isIntersecting) { if (mine) { mine = false; set(false); } return; }
      if (e.boundingClientRect.top >= window.innerHeight) { mine = true; set(true); }
    }).observe(target);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* عالم سمسم – تشجيع الدفع أونلاين: سطر صغير فوق زرار «إتمام الطلب» في السلة */
(function () {
  return; /* اتشال: مكرر مع smsm-paynote */ window.SMSMPAYNOTE = 1;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var TXT = EN
    ? '<b>💳 Pay online (card or InstaPay)</b> — your order is confirmed instantly and prepared faster, with no confirmation call or deposit.'
    : '<b>💳 ادفع أونلاين (كارت أو InstaPay)</b> — طلبك يتأكد فورًا ويتجهز أسرع، من غير مكالمة تأكيد أو ديبوزيت.';
  function add() {
    document.querySelectorAll('button[name="checkout"], .cart__checkout-button').forEach(function (b) {
      var box = b.parentElement;
      if (!box || box.querySelector('.smsm-paynote')) return;
      var p = document.createElement('p'); p.className = 'smsm-paynote'; p.dir = EN ? 'ltr' : 'rtl';
      p.style.cssText = 'margin:0 0 10px;padding:10px 12px;border-radius:12px;background:#F3FBF5;border:1px solid #CDE9D5;color:#14532D;font-size:13px;line-height:1.6;text-align:start';
      p.innerHTML = TXT;
      box.insertBefore(p, b);
    });
  }
  function run() { add(); new MutationObserver(function () { add(); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* عالم سمسم – ربط طلبات الواتساب بمصدرها: بنحفظ أول مصدر جه منه العميل (إعلان فيسبوك/إنستجرام، إعلان جوجل، جوجل بحث...)
   ونضيف سطر صغير «المصدر: ...» لرسالة الواتساب، علشان خدمة العملاء تكتبه في الطلب اليدوي (Draft) */
(function () {
  if (window.SMSMWASRC) return; window.SMSMWASRC = 1;
  var K = 'smsm_src';
  function detect() {
    var q = new URLSearchParams(location.search), us = (q.get('utm_source') || '').toLowerCase(), r = document.referrer || '';
    if (q.get('fbclid') || /facebook|fb|instagram|ig|meta/.test(us)) return /instagram|ig/.test(us) ? 'IG-AD' : 'FB-AD';
    if (q.get('gclid') || q.get('gbraid') || q.get('wbraid') || /google/.test(us)) return 'GOOGLE-AD';
    if (us) return us.toUpperCase().slice(0, 20);
    if (/google\./.test(r)) return 'GOOGLE-SEARCH';
    if (/facebook\.com|fb\.com/.test(r)) return 'FACEBOOK';
    if (/instagram\.com/.test(r)) return 'INSTAGRAM';
    if (/tiktok\.com/.test(r)) return 'TIKTOK';
    return '';
  }
  var cur = detect(), saved = null;
  try { saved = JSON.parse(localStorage.getItem(K) || 'null'); } catch (e) {}
  if (cur && (!saved || Date.now() - saved.t > 30 * 864e5)) { saved = { s: cur, t: Date.now() }; try { localStorage.setItem(K, JSON.stringify(saved)); } catch (e) {} }
  var src = (saved && saved.s) || 'DIRECT';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"], a[href*="whatsapp.com/send"]');
    if (!a || a.dataset.smsmSrc) return;
    try {
      var u = new URL(a.href, location.href), t = u.searchParams.get('text') || '';
      u.searchParams.set('text', (t ? t + '\n' : '') + '(المصدر: ' + src + ')');
      a.href = u.toString(); a.dataset.smsmSrc = '1';
    } catch (err) {}
  }, true);
})();

/* عالم سمسم – وصف المنتج: إخفاء الجزء الأول (قصة العطر/المجموعة/البخور أو العنوان الإبداعي) وحذف جزء «من عالم سمسم» من العرض */
(function () {
  if (window.SMSMDESC) return; window.SMSMDESC = 1;
  var STRUCT = /محتويات|مقدمة|Top Notes|الطابع|الهرم|مواصفات|المكونات|تفاصيل|العائلة|مكونات|طريقة الاستخدام|محتوى|نوتات|الافتتاحية|المقدمة|القلب|القاعدة/;
  function isH(el) { return el && /^H[1-6]$/.test(el.tagName); }
  function latin(t) { var l = 0, a = 0; for (var i = 0; i < t.length; i++) { var c = t.charCodeAt(i); if ((c >= 65 && c <= 90) || (c >= 97 && c <= 122)) l++; else if (c >= 0x600 && c <= 0x6FF) a++; } return l > a; }
  function norm(t) { return (t || '').replace(/[\s|–\-]+/g, '').slice(0, 10); }
  function untilNext(h) { var out = [h], n = h.nextElementSibling; while (n && !isH(n)) { out.push(n); n = n.nextElementSibling; } return out; }
  function run(box) {
    var hs = [].filter.call(box.children, isH);
    if (!hs.length) return;
    hs.forEach(function (h) { if (/من عالم سمسم|من سمسم ورلد|^\s*From\s+(SMSM|Smsm|Alam|Aalam|Sesame|Semsem)\b/i.test(h.textContent)) untilNext(h).forEach(function (x) { x.remove(); }); });
    if (box.querySelector('.smsm-story-h')) return;
    hs = [].filter.call(box.children, isH);
    var h1 = document.querySelector('h1'), title = norm(h1 && h1.textContent);
    for (var i = 0; i < hs.length; i++) {
      var t = hs[i].textContent.trim();
      if (latin(t) || (title && norm(t) === title) || /^(عطر|مجموعة|بخور|مسك|طقم)\s/.test(t) && i === 0) continue;
      if (STRUCT.test(t) || !hs[i + 1]) return;
      untilNext(hs[i]).forEach(function (x) { x.style.display = 'none'; x.classList.add('smsm-story-h'); });
      return;
    }
  }
  function scan() { document.querySelectorAll('.smsm-desc:not(.smsm-desc--plain)').forEach(run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(scan, ms); });
})();

/* عالم سمسم – وصف المنتج: إخفاء فقرات المقدمة اللي تحت اسم المنتج مباشرةً (قبل أول عنوان زي «مواصفات المنتج» أو «الهرم العطري»)
   السطر الإنجليزي اللي فيه اسم المنتج بيفضل ظاهر */
(function () {
  if (window.SMSMINTRO) return; window.SMSMINTRO = 1;
  function isH(el) { return el && /^H[1-6]$/.test(el.tagName); }
  function latin(t) { var l = 0, a = 0; for (var i = 0; i < t.length; i++) { var c = t.charCodeAt(i); if ((c >= 65 && c <= 90) || (c >= 97 && c <= 122)) l++; else if (c >= 0x600 && c <= 0x6FF) a++; } return l > a; }
  function run(box) {
    var first = box.firstElementChild;
    while (first && !first.textContent.trim() && !isH(first)) first = first.nextElementSibling;
    if (!isH(first)) return;
    var n = first.nextElementSibling;
    while (isH(n) && latin(n.textContent)) n = n.nextElementSibling;
    var list = [];
    while (n && !isH(n)) { list.push(n); n = n.nextElementSibling; }
    if (!n || !list.length) return;
    var k = 0;
    var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0; function so(e) { var s = e.querySelector('strong'); return !!s && s.textContent.trim() === e.textContent.trim(); } while (k < list.length && ((EN ? so(list[k]) : latin(list[k].textContent)) || !list[k].textContent.trim())) k++; if (EN && /^(the\s+)?((fragrance|perfume|scent|bakhoor|incense)\s+)?story\b/i.test(n.textContent.trim())) { var m = n; do { m.style.display = 'none'; m.classList.add('smsm-intro-h'); m = m.nextElementSibling; } while (m && !isH(m)); }
    for (; k < list.length; k++) { list[k].style.display = 'none'; list[k].classList.add('smsm-intro-h'); }
  }
  function scan() { document.querySelectorAll('.smsm-desc:not(.smsm-desc--plain)').forEach(run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(scan, ms); });
})();

/* عالم سمسم – شريط المميزات في الرئيسية: سطر «أكثر من 135 براند • أكثر من 2000 اختيار • منتجات أصلية» يتحوّل لأرقام دهبي كبيرة بعدّاد */
(function () {
  if (window.SMSMSTATS) return; window.SMSMSTATS = 1;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  function fmt(n) { return EN ? n.toLocaleString('en-US') : String(n); }
  function show(el, n) { el.textContent = el.dataset.pre + fmt(n) + el.dataset.suf; }
  function count(el) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (el.dataset.suf === '%') return;
    var to = +el.dataset.to, t0 = 0;
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 1400); show(el, Math.round(to * (1 - Math.pow(1 - p, 3)))); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function build() {
    var item = document.querySelector('.smsm-features-container .smsm-feature-item');
    if (!item || item.classList.contains('smsm-hero')) return;
    var d = item.querySelector('.smsm-feature-desc');
    if (!d) return;
    var parts = d.textContent.split('•').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!parts.length) return;
    var box = document.createElement('div'); box.className = 'smsm-stats';
    parts.forEach(function (p) {
      var m = p.match(/(\d[\d,]*)\s*([+%])?/), n, pre = '', suf = '', label;
      if (m) {
        n = parseInt(m[1].replace(/,/g, ''), 10);
        label = p.replace(m[0], '').replace(/أكثر من|more than|over/gi, '').trim();
        if (m[2] === '%') suf = '%'; else if (EN) suf = '+'; else pre = '+';
      } else { n = 100; suf = '%'; label = p; }
      var s = document.createElement('div'); s.className = 'smsm-stat';
      var a = document.createElement('span'); a.className = 'smsm-stat__n'; a.dir = 'ltr';
      a.dataset.to = n; a.dataset.pre = pre; a.dataset.suf = suf; show(a, n);
      var b = document.createElement('span'); b.className = 'smsm-stat__l'; b.textContent = label;
      s.appendChild(a); s.appendChild(b); box.appendChild(s);
    });
    d.classList.add('smsm-stats-src');
    d.parentNode.insertBefore(box, d.nextSibling);
    item.classList.add('smsm-hero');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); box.querySelectorAll('.smsm-stat__n').forEach(count); }
      }, { threshold: 0.4 });
      io.observe(box);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  [600, 2000].forEach(function (ms) { setTimeout(build, ms); });
})();


/* عالم سمسم – وصف المنتج (تكملة): إخفاء أي قسم «قصة العطر» في أي مكان في الوصف + أقسام الختام («الخلاصة» وأي عنوان فيه اسم سمسم ورلد) */
(function () {
  if (window.SMSMDESC2) return; window.SMSMDESC2 = 1; [800, 1800, 3500, 7000, 10000].forEach(function (ms) { setTimeout(scan, ms); });
  /* «قصة» لازم تبقى في أول العنوان عشان ما نلمسش منتجات براند «قصة» (Gissah) */
  var RX = /^[^؀-ۿa-zA-Z]*(قصة|قصّة|القصة)|الخلاصة|الخلاصه|خلاصة القول|(من|في|على|مع)\s*(عالم سمسم|سمسم ورلد)|متوفرة? الآن|متوفّر الآن|سمسم ورلد بيقول|^[^a-zA-Z]*(the\s+)?((fragrance|perfume|scent|collection)\s+)?story\b|\bconclusion\b|\bin summary\b|\bthe bottom line\b|\b(from|at|with)\s+smsm\s*world\b/i;
  var BR = /سمسم ورلد|عالم سمسم|\bsmsm\s*world\b/i;
  function isH(el) { return el && /^H[1-6]$/.test(el.tagName); }
  function run(box) {
    /* بيتعاد كل مرة لأن smsm-desc بيعيد بناء الوصف */
    var hs = [].filter.call(box.children, isH);
    if (!hs.length) return;
    var hit = hs.filter(function (h, i) { var t = h.textContent; return RX.test(t) || (i === hs.length - 1 && BR.test(t)); });
    if (!hit.length) { box.dataset.smsmD2 = 1; return; }
    if (hit.length >= hs.length) return; /* منخفيش الوصف كله */
    hit.forEach(function (h) {
      var n = h; do { n.style.display = 'none'; n.classList.add('smsm-d2-h'); n = n.nextElementSibling; } while (n && !isH(n));
    });
    box.dataset.smsmD2 = 1;
  }
  function scan() { document.querySelectorAll('.smsm-desc:not(.smsm-desc--plain)').forEach(run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(scan, ms); });
})();
